import Languages, { defaultLanguage } from "pages/config/Languages";
import { CURRENT_LANGUAGE } from "pages/constants/StorageKeys";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "pages/Hooks/useLocalStorage";

export function getCurrentLanguage() {
  const availableLanguages = Object.keys(Languages);
  const currentLanguage = getLocalStorageItem(CURRENT_LANGUAGE);
  if (availableLanguages.includes(currentLanguage)) {
    return currentLanguage;
  }
  setCurrentLanguage(defaultLanguage);
  return defaultLanguage;
}

export function setCurrentLanguage(language: string) {
  return setLocalStorageItem(CURRENT_LANGUAGE, language);
}
